let navbar = document.getElementById("navigation-bar");
let navGroup = document.getElementById("navigation-group");
let navLogo = document.getElementById("navigation-logo");
let navLinks = document.getElementsByClassName("navbar__link");

try {
	window.onscroll = function () {
		if (screen.width > 1025) {
			scrollFunction();
		}
	};
} catch (err) {}

function scrollFunction() {
	try {
		if (
			document.body.scrollTop > 50 ||
			document.documentElement.scrollTop > 50
		) {
			navbar.style.height = "100px";
			navbar.style.background = "#F0FFFC";
			navGroup.style.maxHeight = "100px";
			navbar.style.boxShadow = "0px 3px 20px rgba(0, 0, 0, 0.06)";
			// navLogo.style.height = "40%";
			// Array.from(navLinks).forEach((e) => (e.style.fontSize = "10px"));
		} else {
			navbar.style.height = "160px";
			navbar.style.background = "unset";
			navGroup.style.maxHeight = "160px";
			navbar.style.boxShadow = "unset";
			// navLogo.style.height = "30%";
			// Array.from(navLinks).forEach((e) => (e.style.fontSize = "14px"));
		}
	} catch (err) {}
}
